import { environment } from "environments/environment";
import { AppEnvConfig } from "../interfaces/app-config.interface";

export const APP_CONFIG: AppEnvConfig = {
  appName: environment.appConfig.appName,
  theme: environment.appConfig.theme,
  manualUrl: environment.appConfig.manualUrl,
  minPasswordSize: environment.appConfig.minPasswordSize,

  logoLight: environment.appConfig.logoLight,
  logoDark: environment.appConfig.logoDark,
  isotype: environment.appConfig.isotype,

  labels: environment.appConfig.labels,
  featureFlags: environment.appConfig.featureFlags,
};
